module.exports = __webpack_public_path__ + "static/media/developer_section_settings.9052ee2b.svg";